// Dependencies
import Select from 'react-select';
import styled, { css } from 'styled-components';
import { Helpers } from '../../utils';

// Types
//import { Components, Types } from "../../types";

const DropdownSelect = ({ options, selected, onSelect }: any) => {

    const handleChange = (option: any) => onSelect(option.value);

    return (
        <DropdownSelectWrapper>
            <Select
                openMenuOnFocus={true}
                blurInputOnSelect={true}
                isSearchable={false}
                isOptionDisabled={(option) => !option.available}
                value={options.find((option: any) => option.selected)}
                onChange={handleChange}
                classNamePrefix="wooptima"
                className="select__options"
                options={options} />
        </DropdownSelectWrapper>
    )

}

// TODO: Configurable
const DropdownSelectWrapper = styled.div(
({ theme: { general, components: { productAttributes: style } } }) => css`
     .wooptima {

    &__control {
        cursor: pointer;
        border-radius: 0;
        border-width: .15em;
        border-color: #ccc;

        &--is-focused {
            border-color: #000000;
            box-shadow: 0 0 0 .25em rgba(#000, .1);
        }
    }

    &__value-container {
        ${Helpers.clamp('padding', 0.85, 1, 2.5)}
    }

    &__menu {

        & {

            border-radius: 0;
            border-color: #000000;
        }
        
        &-list {
            padding: 0;
            border-radius: 0;
        }

    }

    &__option {

        & {
            ${Helpers.clamp('padding', 0.85, 1, 2.5)}
            cursor: pointer;
        }
        
        &--is-focused {
            background-color: rgba(#000, .1);
        }

        &--is-selected {
            background-color: #000;
        }

    }

}


`);

export default DropdownSelect;